export type IdentityCardTypesResponseBody = {
  code: string;
  name: string;
};
export type GetIdentityCardTypesApiResponse = /** status 200  */ IdentityCardTypesResponseBody[];

export type GetIdentityCardTypesArg = void;
